import { createAction, createSlice } from "@reduxjs/toolkit";
import { Document } from "../../@types/document";
import { Message } from "../../@types/message";
import { User } from "../../@types/user";
import { UserRole } from "../../@types/userRole";
import {UserFile} from "../../@types/userFiles";
import { updateUser } from "../userUpdate/actions/update-user";
import { findUser } from "./actions/find-user";
import { findUserMessages } from "./actions/find-user-messages";
import { findDocuments } from "./actions/findDocuments";
import { findUserRoles } from "./actions/findUserRoles";
import { findUserDocuments} from "./actions/findUserDocuments";
interface UserState {
  user?: User;
  userFetchStatus?: string;
  documents: Document[];
  messages?: Message[];
  messagesFetchStatus: string;
  userRoles?: UserRole[];
  documentSearchText?: string;
  segmentSelected: string;
  userDocumentsList?:UserFile[];
  userDocumentsFetchStatus?: string
}

const initialState = {
  user: {},
  userFetchStatus: "",
  messagesFetchStatus: "",
  documentSearchText: "",
  segmentSelected: "history",
  userDocumentsFetchStatus: ""
} as UserState;

export const setDocumentSearchText = createAction<string>("setDocumentSearchText");
export const setSegmentSelected = createAction<string>("SET_SEGMENT_SELECTED");

const userShowSlice = createSlice({
  name: "userShow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findUser.pending, (state) => {
        state.segmentSelected = "history";
        state.userFetchStatus = "pending";
        state.user = {};
      })
      .addCase(findUser.fulfilled, (state, { payload }) => {
        state.user = payload;
        state.userFetchStatus = "fulfilled";
      })
      .addCase(findUserMessages.pending, (state, { payload }) => {
        state.messages = [];
        state.messagesFetchStatus = "pending";
      })
      .addCase(findUserMessages.fulfilled, (state, { payload }) => {
        state.messages = payload;
        state.messagesFetchStatus = "fulfilled";
      })
      .addCase(updateUser.fulfilled, (state, { payload }) => {
        state.user = payload as User;
      })
      .addCase(findUserRoles.fulfilled, (state, { payload }) => {
        state.userRoles = payload;
      })
      //
      .addCase(setDocumentSearchText, (state, { payload }) => {
        state.documentSearchText = payload;
      })
      // findDocuments
      .addCase(findDocuments.pending, (state) => {
        state.documents = [];
      })
      .addCase(findDocuments.fulfilled, (state, { payload }) => {
        const [documents] = payload;
        state.documents.push(...documents);
      })
      //
      .addCase(setSegmentSelected, (state, { payload }) => {
        state.segmentSelected = payload;
      })
      //Find User Documents 
      .addCase(findUserDocuments.pending, (state) => {
        state.userDocumentsFetchStatus = "pending";
        state.userDocumentsList = [];
      })
      .addCase(findUserDocuments.fulfilled, (state, { payload }) => {
        state.userDocumentsList = payload;
        state.userDocumentsFetchStatus = "fulfilled";
      })
  },
});

export default userShowSlice.reducer;
